import { atom } from 'jotai'
import { viemPublicClients, wagmiConfig } from 'services/wallet/chains'
import { Address, isAddressEqual, zeroAddress } from 'viem'
import { createAtomsWithQuery } from '../atomic-factory'
import { QUERY_IS_USER_CONTRACT_STATUS } from '../keys'
import { DEFAULT_REFETCH_INTERVAL } from '../refetch-intervals'
import { UserContractStatusRequestAtoms } from './model'

const userContractStatusQuery = async <T>({
  queryKey: [, address],
}: {
  queryKey: [string, Address]
}) => {
  if (isAddressEqual(address, zeroAddress)) {
    return false as T
  }
  const bytecode = await viemPublicClients[wagmiConfig.getClient().chain.id].getBytecode({
    address,
  })

  return (bytecode !== undefined) as T
}

export const userContractStatusAtomsFactory = () => {
  const userAddressAtom = atom<Address>(zeroAddress)

  const mainProperties = createAtomsWithQuery<boolean, Address, null, null, [string, Address]>(
    { first: userAddressAtom },
    QUERY_IS_USER_CONTRACT_STATUS,
    userContractStatusQuery<boolean>,
    DEFAULT_REFETCH_INTERVAL,
    'userContractStatusQuery',
  )

  return {
    userAddress: userAddressAtom,
    ...mainProperties,
  } as UserContractStatusRequestAtoms
}
